import {store} from '../components/worksheetStore';
import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import appContainer from '@/components/AppContainer'
import hub from '@/components/AppHub'
import selectArtimeticTables from '@/components/math/selectArtimeticTables'
import worksheet from '@/components/worksheets/worksheet'
import completedWorksheet from '@/components/worksheets/completed'
import setTrainee from '@/components/trainee/setTrainee'

Vue.use(Router)


var foo = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: home
    },

    {
      path: '/app',
      name: 'app',
      component: appContainer,
      redirect: "app/hub",
      children: [
        {
          path: 'trainee/:id?',
          name: 'trainee',
          component: setTrainee
        },
        {
          path: 'hub',
          name: 'hub',
          component: hub
        },
        {
          path: 'startArtimeticTables/:operation',
          name: 'startArtimeticTables',
          component: selectArtimeticTables
        },

        {
          path: 'worksheet/:id?',
          name: 'worksheet',
          component: worksheet
        }, {
          path: 'worksheet/completed/:id?',
          name: 'completedWorksheet',
          component: completedWorksheet
        }
      ]

    }


  ]
})

foo.beforeEach((to, from, next) => {
  if(to.name === "trainee" ||  (store.state.traineeId && store.state.traineeId.length >4)) {
    next();
  }
  else  {
    console.log("No trainee set!");
    next("/app/trainee");
  }
})

export default foo;



// WEBPACK FOOTER //
// ./src/router/index.js